// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { Environment } from "./utils/environments";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: Environment.getFirebaseApiKey(),
  authDomain: Environment.getFirebaseAuthDomain(),
  projectId: Environment.getFirebaseProjectId(),
  storageBucket: Environment.getFirebaseStorageBucket(),
  messagingSenderId: Environment.getFirebaseMessagingSenderId(),
  appId: Environment.getFirebaseAppId(),
  measurementId: Environment.getFirebaseMeasurementId(),
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
export { auth, analytics };
